import React from 'react';
import { Link } from 'react-router-dom';
import banner from '../assets/images/banners/banner_11.jpg';
import { Parallax, Background } from 'react-parallax';

export default function Banner3() {

    return (
        <Parallax strength={500} className="banner-area">
            <Background className="banner-area-bg">
                <img src={banner} />
            </Background>
        </Parallax>
    );
}

